import type { CommuneAssocieeDeleguee } from "models";
import { Endpoints } from "enums";
import { collectivitesApiClient } from "./apiClients";
import { sortingUtil } from "utils";

/**
 * Récupère toutes les communes associées délégues et les retourne triées par nom
 * @returns Array<CommuneAssocieeDeleguee>
 */
async function getAll(): Promise<Array<CommuneAssocieeDeleguee>> {
  const url = Endpoints.COMMUNES_ASSOCIEES_DELEGUEES;
  const data = await collectivitesApiClient.get<
    Array<CommuneAssocieeDeleguee>,
    Array<CommuneAssocieeDeleguee>
  >(url);
  return data
    .map<CommuneAssocieeDeleguee>(({ id, libelle }) => ({
      _type: "commune-associee-deleguee",
      id,
      libelle,
    }))
    .sort(sortingUtil.sortCommunes);
}

export const communesAssocieesDelegueesService = {
  getAll,
};
